import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { DeleteModalComponent } from './delete-modal.component';
import { CygovButtonModule } from 'app/shared/cygov-button/cygov-button.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [DeleteModalComponent],
  imports: [CommonModule, SvgIconModule, CygovButtonModule, FormsModule, NgbModule, A11yModule],
  exports: [DeleteModalComponent],
})
export class DeleteModalModule {}
